<template>
  <div>
    <!-- body -->
    <section class="mt-10">
      <ul>
        <li
          @click="selectPaymentMethod('crypto')"
          class="flex items-center justify-between px-3 lg:px-5 py-3 rounded-lg shadow my-6 cursor-pointer hover:opacity-70"
        >
          <div class="flex items-center gap-x-3 lg:gap-x-5">
            <usdc-ethereum />
            <span class="flex flex-col text-white">
              <span class="font-medium">Crypto Wallet</span>
              <span class="font-thin text-xs">Only Available in USDC</span>
            </span>
          </div>
          <div></div>
        </li>
        <li
          class="flex items-center justify-between px-3 lg:px-5 py-3 rounded-lg shadow my-6 cursor-not-allowed hover:opacity-70"
        >
          <div class="flex items-center gap-x-3 lg:gap-x-5">
            <bank-icon />
            <span class="flex flex-col text-white">
              <span class="font-medium">Bank Account</span>
              <span class="font-thin text-xs">Wire Transfer</span>
            </span>
          </div>
          <div>
            <span
              class="rounded px-2 md:px-4 py-2 shadow text-xs font-thin text-white coming-soon"
              >Coming Soon</span
            >
          </div>
        </li>
        <li
          class="flex items-center justify-between px-3 lg:px-5 py-3 rounded-lg shadow my-6 cursor-not-allowed hover:opacity-70"
        >
          <div class="flex items-center gap-x-3 lg:gap-x-5">
            <wallet-icon />
            <span class="flex flex-col text-white">
              <span class="font-medium">Wallet Connect</span>
              <span class="font-thin text-xs">Only Available in USDC</span>
            </span>
          </div>
          <div>
            <span
              class="rounded px-2 md:px-4 py-2 shadow text-xs font-thin text-white coming-soon"
              >Coming Soon</span
            >
          </div>
        </li>
        <li
          class="flex items-center justify-between px-3 lg:px-5 py-3 rounded-lg shadow my-6 cursor-not-allowed hover:opacity-70"
        >
          <div class="flex items-center gap-x-3 lg:gap-x-5">
            <span>
              <img :src="coinbase" alt="" />
            </span>
            <span class="flex flex-col text-white">
              <span class="font-medium">Coin Base</span>
              <span class="font-thin text-xs">Only Available in USDC</span>
            </span>
          </div>
          <div>
            <span
              class="rounded px-2 md:px-4 py-2 shadow text-xs font-thin text-white coming-soon"
              >Coming Soon</span
            >
          </div>
        </li>
        <li
          class="flex items-center justify-between px-3 lg:px-5 py-3 rounded-lg shadow my-6 cursor-not-allowed hover:opacity-70"
        >
          <div class="flex items-center gap-x-3 lg:gap-x-5">
            <span>
              <img :src="metamask" alt="" />
            </span>
            <span class="flex flex-col text-white">
              <span class="font-medium">Metamask</span>
              <span class="font-thin text-xs">Only Available in USDC</span>
            </span>
          </div>
          <div>
            <span
              class="rounded px-2 md:px-4 py-2 shadow text-xs font-thin text-white coming-soon"
              >Coming Soon</span
            >
          </div>
        </li>
        <li
          class="flex items-center justify-between px-3 lg:px-5 py-3 rounded-lg shadow my-6 cursor-not-allowed hover:opacity-70"
        >
          <div class="flex items-center gap-x-3 lg:gap-x-5">
            <wallet-icon />
            <span class="flex flex-col text-white">
              <span class="font-medium">Card Payment</span>
              <span class="font-thin text-xs">Only Available in USDC</span>
            </span>
          </div>
          <div>
            <span
              class="rounded px-2 md:px-4 py-2 shadow text-xs font-thin text-white coming-soon"
              >Coming Soon</span
            >
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import coinbase from '@/assets/images/coinbase.png'
import metamask from '@/assets/images/metamask.png'
export default {
  components: {
    UsdcEthereum: () => import('@/assets/icons/UsdcEthIcon.vue'),
    BankIcon: () => import('@/assets/icons/BankIcon.vue'),
    WalletIcon: () => import('@/assets/icons/WalletIcon.vue')
  },
  data () {
    return {
      coinbase,
      metamask,
      details: {
        paymentType: '',
        assetType: ''
      }
    }
  },
  methods: {
    selectPaymentMethod (paymentType) {
      this.details.paymentType = paymentType
      const payload = {
        details: this.details,
        view: 'crypto-payment'
      }
      this.$emit('setView', payload)
    }
  }
}
</script>

<style scoped>
/* element styles */
li {
  background: rgba(158, 158, 158, 0.1);
  border: 1px solid rgba(252, 252, 252, 0.1);
  border-radius: 6px;
  transition: all 0.1s ease-in;
}
.coming-soon {
  background: rgba(255, 205, 255, 0.51);
  border-radius: 20px;
}
</style>
